import React from 'react';

const Dashboard = () => {
  return (
    <div className='p-4'>
      <h1></h1>
    </div>
  );
};

export default Dashboard;
